<template>
  <v-sheet style="border-radius: 4px" :class="{ sticky: active }" id="nav">
    <div style="display: flex; justify-content: center; align-items: center">
      <v-tabs
        id="nav-container"
        :class="toggleNavClass()"
        color="transparent"
        center-active
        icons
        class="d-flex align-center justify-center py-2"
        v-model="tab"
        style="height: 52px !important"
      >
        <v-tab
          replace
          :style="
            $route.name == 'personal-info'
              ? 'background-color: #643C64; color: white; border-radius: 3px'
              : ''
          "
          :to="{ name: 'personal-info' }"
        >
          <svg
            version="1.1"
            width="25"
            id="Layer_1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            x="0px"
            y="0px"
            viewBox="0 0 122.88 121.42"
            style="enable-background: new 0 0 122.88 121.42"
            xml:space="preserve"
          >
            <g>
              <path
                :fill="$route.name == 'personal-info' ? '#fff' : '#2c2c2c'"
                class="st0"
                d="M0,121.42l0-19.63c10.5-4.67,42.65-13.56,44.16-26.41c0.34-2.9-6.5-13.96-8.07-19.26 c-3.36-5.35-4.56-13.85-0.89-19.5c1.46-2.25,0.84-10.44,0.84-13.53c0-30.77,53.92-30.78,53.92,0c0,3.89-0.9,11.04,1.22,14.1 c3.54,5.12,1.71,14.19-1.27,18.93c-1.91,5.57-9.18,16.11-8.56,19.26c2.31,11.74,32.13,19.63,41.52,23.8l0,22.23L0,121.42L0,121.42z"
              />
            </g>
          </svg>
          <span v-if="$route.name == 'personal-info'"> المعلومات الشخصية</span>
        </v-tab>
        <v-tab
          replace
          :style="
            $route.name == 'jop-info'
              ? 'background-color: #643C64; color: white; border-radius: 3px'
              : ''
          "
          :to="{ name: 'jop-info' }"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_182_1552)">
              <path
                :fill="$route.name == 'jop-info' ? '#fff' : '#2c2c2c'"
                d="M3 0C2.73478 0 2.48043 0.105357 2.29289 0.292893C2.10536 0.48043 2 0.734784 2 1V15C2 15.2652 2.10536 15.5196 2.29289 15.7071C2.48043 15.8946 2.73478 16 3 16H6V12.5C6 12.3674 6.05268 12.2402 6.14645 12.1464C6.24021 12.0527 6.36739 12 6.5 12H9.5C9.63261 12 9.75979 12.0527 9.85355 12.1464C9.94732 12.2402 10 12.3674 10 12.5V16H13C13.2652 16 13.5196 15.8946 13.7071 15.7071C13.8946 15.5196 14 15.2652 14 15V1C14 0.734784 13.8946 0.48043 13.7071 0.292893C13.5196 0.105357 13.2652 0 13 0L3 0ZM4 2.5C4 2.36739 4.05268 2.24021 4.14645 2.14645C4.24021 2.05268 4.36739 2 4.5 2H5.5C5.63261 2 5.75979 2.05268 5.85355 2.14645C5.94732 2.24021 6 2.36739 6 2.5V3.5C6 3.63261 5.94732 3.75979 5.85355 3.85355C5.75979 3.94732 5.63261 4 5.5 4H4.5C4.36739 4 4.24021 3.94732 4.14645 3.85355C4.05268 3.75979 4 3.63261 4 3.5V2.5ZM7 2.5C7 2.36739 7.05268 2.24021 7.14645 2.14645C7.24021 2.05268 7.36739 2 7.5 2H8.5C8.63261 2 8.75979 2.05268 8.85355 2.14645C8.94732 2.24021 9 2.36739 9 2.5V3.5C9 3.63261 8.94732 3.75979 8.85355 3.85355C8.75979 3.94732 8.63261 4 8.5 4H7.5C7.36739 4 7.24021 3.94732 7.14645 3.85355C7.05268 3.75979 7 3.63261 7 3.5V2.5ZM10.5 2H11.5C11.6326 2 11.7598 2.05268 11.8536 2.14645C11.9473 2.24021 12 2.36739 12 2.5V3.5C12 3.63261 11.9473 3.75979 11.8536 3.85355C11.7598 3.94732 11.6326 4 11.5 4H10.5C10.3674 4 10.2402 3.94732 10.1464 3.85355C10.0527 3.75979 10 3.63261 10 3.5V2.5C10 2.36739 10.0527 2.24021 10.1464 2.14645C10.2402 2.05268 10.3674 2 10.5 2ZM4 5.5C4 5.36739 4.05268 5.24021 4.14645 5.14645C4.24021 5.05268 4.36739 5 4.5 5H5.5C5.63261 5 5.75979 5.05268 5.85355 5.14645C5.94732 5.24021 6 5.36739 6 5.5V6.5C6 6.63261 5.94732 6.75979 5.85355 6.85355C5.75979 6.94732 5.63261 7 5.5 7H4.5C4.36739 7 4.24021 6.94732 4.14645 6.85355C4.05268 6.75979 4 6.63261 4 6.5V5.5ZM7.5 5H8.5C8.63261 5 8.75979 5.05268 8.85355 5.14645C8.94732 5.24021 9 5.36739 9 5.5V6.5C9 6.63261 8.94732 6.75979 8.85355 6.85355C8.75979 6.94732 8.63261 7 8.5 7H7.5C7.36739 7 7.24021 6.94732 7.14645 6.85355C7.05268 6.75979 7 6.63261 7 6.5V5.5C7 5.36739 7.05268 5.24021 7.14645 5.14645C7.24021 5.05268 7.36739 5 7.5 5ZM10 5.5C10 5.36739 10.0527 5.24021 10.1464 5.14645C10.2402 5.05268 10.3674 5 10.5 5H11.5C11.6326 5 11.7598 5.05268 11.8536 5.14645C11.9473 5.24021 12 5.36739 12 5.5V6.5C12 6.63261 11.9473 6.75979 11.8536 6.85355C11.7598 6.94732 11.6326 7 11.5 7H10.5C10.3674 7 10.2402 6.94732 10.1464 6.85355C10.0527 6.75979 10 6.63261 10 6.5V5.5ZM4.5 8H5.5C5.63261 8 5.75979 8.05268 5.85355 8.14645C5.94732 8.24021 6 8.36739 6 8.5V9.5C6 9.63261 5.94732 9.75979 5.85355 9.85355C5.75979 9.94732 5.63261 10 5.5 10H4.5C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5V8.5C4 8.36739 4.05268 8.24021 4.14645 8.14645C4.24021 8.05268 4.36739 8 4.5 8ZM7 8.5C7 8.36739 7.05268 8.24021 7.14645 8.14645C7.24021 8.05268 7.36739 8 7.5 8H8.5C8.63261 8 8.75979 8.05268 8.85355 8.14645C8.94732 8.24021 9 8.36739 9 8.5V9.5C9 9.63261 8.94732 9.75979 8.85355 9.85355C8.75979 9.94732 8.63261 10 8.5 10H7.5C7.36739 10 7.24021 9.94732 7.14645 9.85355C7.05268 9.75979 7 9.63261 7 9.5V8.5ZM10.5 8H11.5C11.6326 8 11.7598 8.05268 11.8536 8.14645C11.9473 8.24021 12 8.36739 12 8.5V9.5C12 9.63261 11.9473 9.75979 11.8536 9.85355C11.7598 9.94732 11.6326 10 11.5 10H10.5C10.3674 10 10.2402 9.94732 10.1464 9.85355C10.0527 9.75979 10 9.63261 10 9.5V8.5C10 8.36739 10.0527 8.24021 10.1464 8.14645C10.2402 8.05268 10.3674 8 10.5 8Z"
              />
            </g>
            <defs>
              <clipPath id="clip0_182_1552">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span v-if="$route.name == 'jop-info'">معلومات الوظيفه</span>
        </v-tab>
        <v-tab
          replace
          :style="
            $route.name == 'attachments-profile'
              ? 'background-color: #643C64; color: white; border-radius: 3px'
              : ''
          "
          :to="{ name: 'attachments-profile' }"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              :fill="$route.name == 'attachments-profile' ? '#fff' : '#2c2c2c'"
              d="M5.5998 12.8H4.7998V11.2H5.5998C5.81198 11.2 6.01546 11.2842 6.16549 11.4343C6.31552 11.5843 6.3998 11.7878 6.3998 12C6.3998 12.2121 6.31552 12.4156 6.16549 12.5656C6.01546 12.7157 5.81198 12.8 5.5998 12.8ZM11.1998 16V11.2H11.9998C12.212 11.2 12.4155 11.2842 12.5655 11.4343C12.7155 11.5843 12.7998 11.7878 12.7998 12V15.2C12.7998 15.4121 12.7155 15.6156 12.5655 15.7656C12.4155 15.9157 12.212 16 11.9998 16H11.1998Z"
            />
            <path
              :fill="$route.name == 'attachments-profile' ? '#fff' : '#2c2c2c'"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M1.59961 2.4C1.59961 1.76348 1.85247 1.15303 2.30255 0.702944C2.75264 0.252856 3.36309 0 3.99961 0L17.1308 0L22.3996 5.2688V21.6C22.3996 22.2365 22.1468 22.847 21.6967 23.2971C21.2466 23.7471 20.6361 24 19.9996 24H3.99961C3.36309 24 2.75264 23.7471 2.30255 23.2971C1.85247 22.847 1.59961 22.2365 1.59961 21.6V2.4ZM5.59961 9.6H3.19961V17.6H4.79961V14.4H5.59961C6.23613 14.4 6.84658 14.1471 7.29667 13.6971C7.74675 13.247 7.99961 12.6365 7.99961 12C7.99961 11.3635 7.74675 10.753 7.29667 10.3029C6.84658 9.85286 6.23613 9.6 5.59961 9.6ZM11.9996 9.6H9.59961V17.6H11.9996C12.6361 17.6 13.2466 17.3471 13.6967 16.8971C14.1468 16.447 14.3996 15.8365 14.3996 15.2V12C14.3996 11.3635 14.1468 10.753 13.6967 10.3029C13.2466 9.85286 12.6361 9.6 11.9996 9.6ZM15.9996 17.6V9.6H20.7996V11.2H17.5996V12.8H19.1996V14.4H17.5996V17.6H15.9996Z"
            />
          </svg>

          <span v-if="$route.name == 'attachments-profile'"> مرفقات الملف الشخصى</span>
        </v-tab>
        <v-tab
          replace
          :style="
            $route.name == 'user-qualification'
              ? 'background-color: #643C64; color: white; border-radius: 3px'
              : ''
          "
          :to="{ name: 'user-qualification' }"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              :fill="$route.name == 'user-qualification' ? '#fff' : '#2c2c2c'"
              d="M5 17.749V13.983L9.06 16.636C9.93417 17.2072 10.9558 17.5114 12 17.5114C13.0442 17.5114 14.0658 17.2072 14.94 16.636L19 13.983V17.749C19 17.9113 18.9474 18.0692 18.85 18.199L18.849 18.201L18.848 18.202L18.845 18.206L18.836 18.216L18.824 18.232L18.811 18.249L18.725 18.35C18.6241 18.4646 18.5184 18.5747 18.408 18.68C18.131 18.947 17.718 19.294 17.158 19.638C16.036 20.328 14.338 20.999 12 20.999C9.661 20.999 7.964 20.329 6.841 19.638C6.39163 19.3642 5.97261 19.0434 5.591 18.681C5.43956 18.535 5.29697 18.3801 5.164 18.217L5.155 18.207L5.152 18.202V18.2C5.0543 18.0703 5.00101 17.9115 5 17.749ZM22.16 10.127L14.12 15.38C13.4897 15.792 12.753 16.0114 12 16.0114C11.247 16.0114 10.5103 15.792 9.88 15.38L3 10.885V16.249C3 16.4479 2.92098 16.6387 2.78033 16.7794C2.63968 16.92 2.44891 16.999 2.25 16.999C2.05109 16.999 1.86032 16.92 1.71967 16.7794C1.57902 16.6387 1.5 16.4479 1.5 16.249V9.99903C1.5 9.91103 1.515 9.82703 1.543 9.74903C1.48668 9.58964 1.48587 9.4159 1.54069 9.25598C1.5955 9.09606 1.70274 8.95936 1.845 8.86804L9.909 3.69804C10.5331 3.29805 11.2588 3.08545 12 3.08545C12.7412 3.08545 13.4669 3.29805 14.091 3.69804L22.155 8.86804C22.2603 8.93565 22.347 9.02855 22.4073 9.13827C22.4675 9.24798 22.4993 9.37102 22.4998 9.49618C22.5003 9.62133 22.4695 9.74462 22.4101 9.85481C22.3508 9.965 22.2648 10.0586 22.16 10.127Z"
            />
          </svg>

          <span v-if="$route.name == 'user-qualification'"> المؤهلات</span>
        </v-tab>
        <v-tab
          replace
          :style="
            $route.name == 'user-bail'
              ? 'background-color: #643C64; color: white; border-radius: 3px'
              : ''
          "
          :to="{ name: 'user-bail' }"
        >
          <svg
            width="24"
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 122.88 105.01"
          >
            <path
              :fill="$route.name == 'user-bail' ? '#fff' : '#2c2c2c'"
              class="cls-1"
              d="M100.86,56.77c8.18,5.19,15.58,7.64,21.92,7.06,1.11,22.42-7.17,35.66-21.84,41.18C86.78,99.84,78.4,87.17,79,63.49a31.35,31.35,0,0,0,21.84-6.72Zm.24,7.81c5.53,3.51,10.53,5.17,14.82,4.78.75,15.15-4.85,24.11-14.77,27.84l-.18-.07V64.68l.13-.1Zm-.23-4.86c7.18,4.55,13.67,6.71,19.24,6.2,1,19.67-6.29,31.29-19.17,36.14C88.51,97.52,81.15,86.4,81.7,65.62a27.52,27.52,0,0,0,19.17-5.9Zm-66.58-9c-1.86-3-5.36-7-5.36-10.47a5.61,5.61,0,0,1,3.77-5.1c-.18-2.94-.3-5.92-.3-8.87,0-1.75,0-3.52.1-5.25a12.37,12.37,0,0,1,.59-2.63A18.65,18.65,0,0,1,41.43,7.79,23.45,23.45,0,0,1,46,5.63c2.86-1,1.48-5.56,4.61-5.63C57.9-.19,70,6.22,74.67,11.32a17.11,17.11,0,0,1,4.8,11.46l-.3,12.84a4.24,4.24,0,0,1,3.09,2.64c1,4.06-3.21,9.1-5.16,12.33-1.81,3-8.7,11.1-8.71,11.16a2.62,2.62,0,0,0,.62,1.5,17.14,17.14,0,0,0,3.45,3.51c.68,13.37,3.91,23.6,9.25,31.18H0C0,68.66,31.47,78,42.16,63.25c.53-.77.77-1.19.76-1.53,0-.19-7.92-9.89-8.63-11Z"
            />
          </svg>
          <span v-if="$route.name == 'user-bail'">الكفالة</span>
        </v-tab>
        <v-tab
          replace
          :style="
            $route.name == 'user-identity'
              ? 'background-color: #643C64; color: white; border-radius: 3px'
              : ''
          "
          :to="{ name: 'user-identity' }"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              :fill="$route.name == 'user-identity' ? '#fff' : '#2c2c2c'"
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M0 5.59995C0 4.96343 0.252856 4.35298 0.702944 3.90289C1.15303 3.45281 1.76348 3.19995 2.4 3.19995H21.6C22.2365 3.19995 22.847 3.45281 23.2971 3.90289C23.7471 4.35298 24 4.96343 24 5.59995V18.4C24 19.0365 23.7471 19.6469 23.2971 20.097C22.847 20.5471 22.2365 20.8 21.6 20.8H2.4C1.76348 20.8 1.15303 20.5471 0.702944 20.097C0.252856 19.6469 0 19.0365 0 18.4L0 5.59995ZM4.8 9.59995C4.8 8.75126 5.13714 7.93733 5.73726 7.33721C6.33737 6.73709 7.15131 6.39995 8 6.39995C8.84869 6.39995 9.66263 6.73709 10.2627 7.33721C10.8629 7.93733 11.2 8.75126 11.2 9.59995C11.2 10.4486 10.8629 11.2626 10.2627 11.8627C9.66263 12.4628 8.84869 12.8 8 12.8C7.15131 12.8 6.33737 12.4628 5.73726 11.8627C5.13714 11.2626 4.8 10.4486 4.8 9.59995ZM19.2 9.59995H14.4V7.99995H19.2V9.59995ZM19.2 14.4H14.4V12.8H19.2V14.4ZM8 14.4C7.13027 14.3999 6.27772 14.6421 5.53789 15.0994C4.79805 15.5566 4.20016 16.2108 3.8112 16.9888L3.2832 18.0416C3.22202 18.1636 3.19311 18.2994 3.19923 18.4358C3.20534 18.5722 3.24628 18.7048 3.31813 18.8209C3.38999 18.937 3.49038 19.0328 3.60973 19.0992C3.72909 19.1655 3.86344 19.2002 4 19.2H12C12.1364 19.1999 12.2706 19.1651 12.3897 19.0986C12.5089 19.0321 12.609 18.9363 12.6807 18.8202C12.7524 18.7041 12.7931 18.5717 12.7992 18.4354C12.8052 18.2991 12.7763 18.1635 12.7152 18.0416L12.1888 16.9888C11.7998 16.2108 11.202 15.5566 10.4621 15.0994C9.72228 14.6421 8.86973 14.3999 8 14.4Z"
            />
          </svg>

          <span v-if="$route.name == 'user-identity'"> الهوية </span>
        </v-tab>
        <v-tab
          replace
          :style="
            $route.name == 'user-notes'
              ? 'background-color: #643C64; color: white; border-radius: 3px'
              : ''
          "
          :to="{ name: 'user-notes' }"
        >
          <svg
            width="25"
            height="25"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              :fill="$route.name == 'user-notes' ? '#fff' : '#2c2c2c'"
              d="M12.25 6C10.5924 6 9.00268 6.65848 7.83058 7.83058C6.65848 9.00268 6 10.5924 6 12.25V35.75C6 37.4076 6.65848 38.9973 7.83058 40.1694C9.00268 41.3415 10.5924 42 12.25 42H26V32.25C26 30.5924 26.6585 29.0027 27.8306 27.8306C29.0027 26.6585 30.5924 26 32.25 26H42V12.25C42 10.5924 41.3415 9.00268 40.1694 7.83058C38.9973 6.65848 37.4076 6 35.75 6H12.25ZM41.447 28.5H32.25C31.2554 28.5 30.3016 28.8951 29.5983 29.5983C28.8951 30.3016 28.5 31.2554 28.5 32.25V41.447C29.1882 41.1362 29.8143 40.7032 30.348 40.169L40.169 30.349C40.7032 29.815 41.1362 29.1885 41.447 28.5Z"
            />
          </svg>
          <span v-if="$route.name == 'user-notes'"> ملاحظات</span>
        </v-tab>
        <v-tab
          replace
          :style="
            $route.name == 'user-holidays'
              ? 'background-color: #643C64; color: white; border-radius: 4px; height: 46px; margin-top: 2px;'
              : ''
          "
          :to="{ name: 'user-holidays' }"
        >
          <svg
            width="24"
            height="24"
            style="margin: 0 0 10px 5px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              :fill="$route.name == 'user-holidays' ? '#fff' : '#2c2c2c'"
              d="M2.75 6C2.75 5.80109 2.67098 5.61032 2.53033 5.46967C2.38968 5.32902 2.19891 5.25 2 5.25C1.80109 5.25 1.61032 5.32902 1.46967 5.46967C1.32902 5.61032 1.25 5.80109 1.25 6V18C1.25 18.1989 1.32902 18.3897 1.46967 18.5303C1.61032 18.671 1.80109 18.75 2 18.75C2.19891 18.75 2.38968 18.671 2.53033 18.5303C2.67098 18.3897 2.75 18.1989 2.75 18V16.75H21.142V18C21.142 18.1989 21.221 18.3897 21.3617 18.5303C21.5023 18.671 21.6931 18.75 21.892 18.75C22.0909 18.75 22.2817 18.671 22.4223 18.5303C22.563 18.3897 22.642 18.1989 22.642 18V15.643C22.642 13.648 22.642 12.651 22.362 11.849C22.1139 11.14 21.7093 10.496 21.1781 9.96488C20.647 9.43374 20.003 9.02909 19.294 8.781C18.492 8.501 17.494 8.501 15.5 8.501H15.498C14.7 8.501 13.66 8.501 13.339 8.612C13.0555 8.71124 12.7979 8.87308 12.5855 9.0855C12.3731 9.29792 12.2112 9.55546 12.112 9.839C12 10.16 12 10.56 12 11.357V15.25H2.75V6Z"
            />
            <path
              :fill="$route.name == 'user-holidays' ? '#fff' : '#2c2c2c'"
              d="M7 13.5C7.66304 13.5 8.29893 13.2366 8.76777 12.7678C9.23661 12.2989 9.5 11.663 9.5 11C9.5 10.337 9.23661 9.70107 8.76777 9.23223C8.29893 8.76339 7.66304 8.5 7 8.5C6.33696 8.5 5.70107 8.76339 5.23223 9.23223C4.76339 9.70107 4.5 10.337 4.5 11C4.5 11.663 4.76339 12.2989 5.23223 12.7678C5.70107 13.2366 6.33696 13.5 7 13.5Z"
            />
          </svg>
          <span
            v-if="$route.name == 'user-holidays'"
            style="height: 38px; margin-top: 6px"
          >
            الاجازات
          </span>
        </v-tab>
      </v-tabs>
    </div>
  </v-sheet>
</template>

<script setup>
import { ref } from "vue";

const tab = ref("");
const active = ref(false);

const toggleNavClass = () => {
  if (active.value == false) {
    return "nav";
  } else {
    return "sticky-nav";
  }
};
</script>
